// import { useEffect } from "react";

// export const useFetchUserDefinedOptions = (fieldNames, setFieldOptions, dependencies,db,groupId,showAllDataFlag, userId) => {
//   useEffect(() => {
//     const fetchUserDefinedOptions = (fieldName, setOptions) => {
//       return db.collection("profiles")
//         .where("groupId", "==", groupId)
//         .onSnapshot((snapshot) => {
//           const userProfiles = [];

//           snapshot.docs.forEach((doc) => {
//             const data = doc.data();
//             if (data?.userDefinedOptions) {
//               const filteredOptions = data.userDefinedOptions.filter(
//                 (option) => option.name === fieldName
//               );
//               userProfiles.push(...filteredOptions);
//             }
//           });

//           const finalResult = userProfiles.map((item) => ({
//             name: fieldName,
//             value: item.value,
//           }));

        
//           setOptions(finalResult);
//         });
//     };

//     fieldNames.forEach((fieldName, index) => {
//       const setOptions = setFieldOptions[index];
//       if (showAllDataFlag) {
//         fetchUserDefinedOptions(fieldName, setOptions);
//       } else {
//         db.collection("profiles").doc(userId).onSnapshot((doc) => {
//           if (doc.exists) {
//             const data = doc.data();
//             if (data?.userDefinedOptions) {
//               const filteredOptions = data.userDefinedOptions.filter(
//                 (option) => option.name === fieldName
//               );
//               const finalResult = filteredOptions.map((item) => ({
//                 name: fieldName,
//                 value: item.value,
//               }));

             
//               setOptions(finalResult);
//             }
//           }
//         });
//       }
//     });
//   }, dependencies);
// };









import { useEffect } from "react";

export const useFetchUserDefinedOptions = (
  fieldNames,
  setFieldOptions,
  dependencies,
  db,
  groupId,
  showAllDataFlag,
  userId
) => {
  useEffect(() => {
    const fetchUserDefinedOptions = (fieldName, setOptions) => {
      return db.collection("profiles")
        .where("groupId", "==", groupId)
        .onSnapshot((snapshot) => {
          const userProfiles = [];

          snapshot.docs.forEach((doc) => {
            const data = doc.data();
            if (data?.userDefinedOptions) {
              const filteredOptions = data.userDefinedOptions.filter(
                (option) => option.name === fieldName
              );
          
              const createdByCurrentUser = data.userId === userId;
              const optionsWithUserFlag = filteredOptions.map((option) => ({
                ...option,
                createdByCurrentUser: createdByCurrentUser, 
              }));
      
              userProfiles.push(...optionsWithUserFlag);
            }
          });

          const finalResult = userProfiles.map((item) => ({
            name: fieldName,
            value: item.value,
            createdByCurrentUser:item.createdByCurrentUser
          }));

          setOptions(finalResult);
        });
    };

    fieldNames.forEach((fieldName, index) => {
      const setOptions = setFieldOptions[index];
      if (showAllDataFlag) {
        fetchUserDefinedOptions(fieldName, setOptions);
      } else {
        db.collection("profiles").doc(userId).onSnapshot((doc) => {
          if (doc.exists) {
            const data = doc.data();
            if (data?.userDefinedOptions) {
              const filteredOptions = data.userDefinedOptions.filter(
                (option) => option.name === fieldName
              );
              const finalResult = filteredOptions.map((item) => ({
                name: fieldName,
                value: item.value,
                createdByCurrentUser:true 
              }));

              setOptions(finalResult);
            }
          }
        });
      }
    });
  }, dependencies);
};
